/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartMedicinesInUseAliases {
  CONTEXTUAL_BAR_MEDICINES_IN_USE = 'contextual-bar-medicines-in-use',
  DECK_MEDICINES_IN_USE = 'deck-medicines-in-use',
  FETCH_MEDICINES_IN_USE = 'fetch-medicines-in-use',
  LAYOUT_MY_CHART_MEDICINES_IN_USE = 'layout-my-chart-medicines-in-use',
  MY_CHART_MEDICINES_IN_USE_CARD = 'my-chart-medicines-in-use-card',
}
export { MyChartMedicinesInUseAliases };
